module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_faq_anchor-966dea8aad1f8cf750837bb1ba586fbf.png";